/* Sezione Pronta IT · landing v3 · piezas propias (2026-10-22)
   Filtro por sezione (opciones escritas en el HTML), visor de fichas, comparación antes/después, vídeo que solo corre a la vista,
   compra (plan, extras, consentimiento UE y carrito) y barra fija SOLO desde la oferta. Sin dependencias.
   Urgencia: solo el reloj de una fecha REAL fija que pone la sección Liquid (cierre Europa 01+02); sin fecha, nada. */
(function () {
  'use strict';
  var raiz = document.querySelector('.sp3'); if (!raiz) return;
  var $ = function (s) { return raiz.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(raiz.querySelectorAll(s)); };

  /* filtro por sezione */
  $$('.sp-filtro input').forEach(function (r) {
    r.addEventListener('change', function () {
      var v = r.value;
      $$('.sp-ficha').forEach(function (f) { var s = f.getAttribute('data-sez'); f.hidden = !(v === 't' || s === v || (s === 'x' && v === 't')); });
      var pista = $('.sp-pista'); if (pista) pista.scrollTo({ left: 0, behavior: 'smooth' });
    });
  });

  /* selector de perfil (opciones escritas en el HTML) */
  $$('.sp-perfil input').forEach(function (r) {
    r.addEventListener('change', function () { $$('.sp-risposta').forEach(function (p) { p.hidden = p.getAttribute('data-perfil') !== r.value; }); });
  });

  /* visor de fichas */
  var visor = $('.sp-visor');
  if (visor && visor.showModal) {
    var img = visor.querySelector('img');
    $$('.sp-ficha').forEach(function (b) {
      b.addEventListener('click', function () { img.src = b.getAttribute('data-grande'); img.alt = (b.querySelector('img') || {}).alt || ''; visor.showModal(); });
    });
    visor.querySelector('.sp-visor-cerrar').addEventListener('click', function () { visor.close(); });
    visor.addEventListener('click', function (e) { if (e.target === visor) visor.close(); });
  }

  /* comparación antes / después */
  $$('.sp-desl').forEach(function (d) {
    var r = d.querySelector('input[type=range]');
    var pon = function () { d.style.setProperty('--x', r.value + '%'); };
    r.addEventListener('input', pon); pon();
  });

  /* vídeo de hojeo: solo mientras se ve */
  var v = $('.sp-hojeo video');
  if (v && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }); }, { threshold: .35 }).observe(v);
  } else if (v) { v.controls = true; }

  /* compra */
  var euro = function (c) { return (c / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };
  var plan = function () { return $('.sp-plan input:checked'); };
  function total() {
    var c = parseInt(plan().getAttribute('data-precio'), 10) || 0;
    $$('[data-extra]').forEach(function (x) { if (x.checked) c += parseInt(x.getAttribute('data-precio'), 10) || 0; });
    var t = $('[data-total]'); if (t) t.textContent = euro(c);
  }
  $$('.sp-plan input,[data-extra]').forEach(function (x) { x.addEventListener('change', total); });
  var cb = $('[data-consent]'), caja = $('[data-caja]'), msg = $('[data-msg]'), btn = $('[data-comprar]');
  if (cb) cb.addEventListener('change', function () { if (cb.checked) { caja.classList.remove('sp-error'); msg.hidden = true; } });
  if (btn) btn.addEventListener('click', function (e) {
    e.preventDefault();
    if (cb && !cb.checked) { caja.classList.add('sp-error'); msg.hidden = false; cb.focus(); return; }
    var items = [plan().getAttribute('data-variante') + ':1'];
    $$('[data-extra]').forEach(function (x) { if (x.checked) items.push(x.getAttribute('data-variante') + ':1'); });
    var url = btn.getAttribute('data-carrito') + '/' + items.join(',');
    var at = btn.getAttribute('data-atributo');
    if (at) url += '?attributes[' + encodeURIComponent(at) + ']=' + encodeURIComponent((btn.getAttribute('data-valor') || 'si') + ' ' + new Date().toISOString());
    if (/PROVA-/.test(url)) { btn.textContent = 'Carrello di prova: ' + items.join(' + '); return; }
    window.location.href = url;
  });
  total();

  /* cierre Europa 01+02 · fecha REAL fija (2026-10-23): fin = data-caduca (AAAA-MM-DD) + data-hora + data-zona.
     Nada se guarda por visita y nada vuelve a empezar; se refresca cada 30 s. Sin fecha (data-caduca vacío), no hace
     nada. Al pasar el fin: .ce-vencido oculta [data-ce-antes] (barra, precio de preventa, contador). */
  var conFecha = $$('[data-ce-fecha]').filter(function (el) { return /^\d{4}-\d{2}-\d{2}$/.test(el.getAttribute('data-caduca') || ''); });
  if (conFecha.length) {
    var finDe = function (el) { var t = Date.parse(el.getAttribute('data-caduca') + 'T' + (el.getAttribute('data-hora') || '23:59') + ':59' + (el.getAttribute('data-zona') || '+01:00')); return isNaN(t) ? null : t; };
    var dos = function (n) { return (n < 10 ? '0' : '') + n; };
    var pintaFecha = function () {
      var ahora = new Date().getTime();
      conFecha.forEach(function (el) {
        var t = finDe(el); if (t === null) return; var resto = t - ahora;
        if (resto <= 0) { el.classList.add('ce-vencido'); if (el.hasAttribute('data-ce-antes')) el.hidden = true; return; }
        var d = Math.floor(resto / 864e5), h = Math.floor(resto % 864e5 / 36e5), m = Math.floor(resto % 36e5 / 6e4);
        el.querySelectorAll('[data-ce-d]').forEach(function (x) { x.textContent = d; });
        el.querySelectorAll('[data-ce-h]').forEach(function (x) { x.textContent = dos(h); });
        el.querySelectorAll('[data-ce-m]').forEach(function (x) { x.textContent = dos(m); });
        el.querySelectorAll('[data-ce-quedan]').forEach(function (x) { x.textContent = d >= 1 ? d + ' ' + x.getAttribute(d === 1 ? 'data-txt-dia' : 'data-txt-dias') : (h || 1) + ' ' + x.getAttribute('data-txt-horas'); });
      });
    };
    pintaFecha(); setInterval(pintaFecha, 30000);
  }

  /* cierre Europa 13 · último pedido REAL (metacampo praxolia.ultimos_pedidos, sin nombres): solo si tiene < 72 h */
  $$('[data-ce-ultimo]').forEach(function (el) {
    var t = Date.parse(el.getAttribute('data-hora')); if (isNaN(t)) return;
    var ahora = new Date(), edad = ahora.getTime() - t; if (edad < 0 || edad > 72 * 36e5) return;
    var d = new Date(t), hoy = d.toDateString() === ahora.toDateString(), ayer = new Date(ahora.getTime() - 864e5).toDateString() === d.toDateString();
    var hh = (d.getHours() < 10 ? '0' : '') + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    var cuando = hoy ? 'oggi alle ' + hh : ayer ? 'ieri alle ' + hh : d.toLocaleDateString('it-IT');
    if (el.getAttribute('data-pais') === 'IT') cuando += ' dall\'Italia';
    el.querySelector('span').textContent = 'Ultimo ordine ricevuto: ' + cuando;
    el.hidden = false;
  });

  /* barra fija: aparece solo desde la sección de la oferta y se esconde con la compra a la vista */
  var fija = $('.fija'), oferta = $('#offerta'), compra = $('#comprar');
  if (fija && oferta && 'IntersectionObserver' in window) {
    var pasada = false, compraVista = false;
    var pinta = function () { var on = pasada && !compraVista; fija.classList.toggle('on', on); fija.setAttribute('aria-hidden', on ? 'false' : 'true'); var a = fija.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (es) { es.forEach(function (e) { pasada = e.boundingClientRect.top < window.innerHeight * 0.6; pinta(); }); }, { threshold: [0, .1, .25, .5, .75, 1] }).observe(oferta);
    if (compra) new IntersectionObserver(function (es) { es.forEach(function (e) { compraVista = e.isIntersecting; pinta(); }); }, { threshold: .25 }).observe(compra);
  }
})();
